<!-- Main Footer -->
<footer class="main-footer text-white">
  Copyright {{currentYear}} <a>{{companyProfile.title}}</a>
  All rights reserved.
  <div class="float-right d-none d-sm-inline-block">
    <b>Version</b> 1.0.0
  </div>
</footer>